/* eslint-disable @typescript-eslint/no-empty-function */
import {
    AnalyticsEventSignupEmailBannerClick,
    AnalyticsEventUserCreate,
    AnalyticsEventWebappSignupDialogSuccessfulSignUp,
} from 'lib/constants/AnalyticsEventType'
import { appKnowRoute } from 'lib/constants/routes'
import theme from 'stories/utils/theme'
import _useTranslation from 'lib/hooks/_useTranslation'
import { trackEvent } from 'lib/tracking/analytics-service'
import { getReferrerScreen } from 'lib/formatting/url'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { AdditionalSignUpAttributes, getDefaultAdditionalSignUpAttributes } from 'lib/tracking/attribution/signupattributes'
import { parseLocale } from 'lib/constants/localization'
import { toast } from 'react-toastify'
import { useEffect, useState } from 'react'
import { KnowSeoInfo } from 'interfaces/KnowSeoInfo'
import ImageBannerBody from './ImageBannerBody'
import { ActiveExperiments } from 'lib/features/activeExperiments'
import DarkThemeImageBannerBody from './DarkThemeAiEnhanced/DarkThemeImageBannerBody'

const Container = styled.div`
    position: absolute;
    z-index: ${theme.zIndex.FAB};
    bottom: 0;
    height: 100%;
    display: flex;
    left: 0;
    right: 0;
`

interface Props {
    knowSeoInfo: KnowSeoInfo
    isSidebarShown: boolean
    index: number
    isDarkTheme?: boolean
    experiments: ActiveExperiments
    showDarkThemeImageBanner?: boolean
}

const ImageSignupBanner = ({ knowSeoInfo, index, isDarkTheme, experiments, showDarkThemeImageBanner }: Props) => {
    const [additionalSignUpAttributes, setAdditionalSignUpAttributes] = useState<AdditionalSignUpAttributes>()
    const { t: tAuth } = _useTranslation('auth')
    const router = useRouter()
    const parsedLocale = parseLocale(router.locale)
    const referrerScreen = getReferrerScreen(router)
    const { know } = knowSeoInfo

    useEffect(() => {
        const attributes = getDefaultAdditionalSignUpAttributes(
            parsedLocale.countryCode,
            parsedLocale.interfaceLanguageCode,
            know.uuid,
            know.universityAuthoredDate ?? null,
            know?.schoolTypes?.[0]?.id ?? null
        )

        setAdditionalSignUpAttributes(attributes)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const bottomReferrerScreen = `know-preview-restriction-content-fixed-banner`

    const redirectAfterGoogleSignIn = () => router.push(appKnowRoute(know.uuid, { referrerScreen: bottomReferrerScreen }))

    const onSuccessSignUp = (isNewAccount: boolean, type: 'google' | 'apple' | 'email') => {
        if (isNewAccount) {
            trackEvent(AnalyticsEventUserCreate, { value: type, referrerScreen })
            toast.success(tAuth('auth/signUpRegisterSuccessMessage'))
        }

        trackEvent(AnalyticsEventWebappSignupDialogSuccessfulSignUp, { referrerScreen, know, valueId: index })

        router.push(appKnowRoute(know?.slug, { referrerScreen }))
        redirectAfterGoogleSignIn()
    }

    const onEmailButtonClick = () => {
        trackEvent(AnalyticsEventSignupEmailBannerClick, { know, referrerScreen })
    }

    const BannerBody = showDarkThemeImageBanner ? DarkThemeImageBannerBody : ImageBannerBody

    return (
        <Container>
            <BannerBody
                additionalSignUpAttributes={additionalSignUpAttributes}
                onSuccessSignup={onSuccessSignUp}
                onEmailButtonClick={onEmailButtonClick}
                knowSeoInfo={knowSeoInfo}
                index={index}
                isDarkTheme={isDarkTheme}
            />
        </Container>
    )
}

export default ImageSignupBanner
